// API and calendar values use YYYY-MM-DD; editable text uses DD.MM.YYYY.
export function formatDate(value) {
  if (!value) return "";
  const [year, month, day] = value.split("-");
  return `${day}.${month}.${year}`;
}

export function parseDate(value) {
  const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec((value || "").trim());
  if (!match) return null;

  const [, day, month, year] = match;
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  const leapYear = y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
  const daysInMonth = [
    31,
    leapYear ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ];
  // Validate calendar dates directly, without timezone conversion or rollover
  // (for example, 31 February must not silently become a date in March).
  if (y < 1 || m < 1 || m > 12 || d < 1 || d > daysInMonth[m - 1]) {
    return null;
  }
  return `${year}-${month}-${day}`;
}
